// extracted by mini-css-extract-plugin
module.exports = {"InfoPopover__icon":"InfoPopover_InfoPopover__icon__1cGSb","InfoPopover":"InfoPopover_InfoPopover__1O1hl"};